export default __webpack_public_path__ + "static/media/NCEgypt.10e47920.png";